import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DetectAdBlock } from '@surfline/quiver-react';
import ForcedRegistrationModal from '../ForcedRegistrationModal';
import EmailVerification from '../EmailVerification';
import RegistrationModal from '../RegistrationModal';
import { SL_REGISTRATION_POPUP_V1 } from '../../common/treatments';
import userDetailsPropType from '../../propTypes/userDetails';
import devicePropTypes from '../../propTypes/device';
import treatmentsPropType from '../../propTypes/treatments';

class RegistrationModals extends Component {
  constructor(props) {
    super(props);
    this.registrationDelayTimer = null;
    this.state = {
      adBlocker: null,
      showEmailVerificationWall: false,
      showRegWall: false,
      showTimedRegistrationModal: false,
    };
  }

  componentDidMount() {
    const { userDetails, doLoadTreatments, pageViews } = this.props;
    if (!userDetails && pageViews > 2) {
      this.handleRegistrationModal();
    }
    if (userDetails && !userDetails.isEmailVerified) {
      const regWallTreatment = doLoadTreatments(SL_REGISTRATION_POPUP_V1);
      if (regWallTreatment === 'Forced_KBYG_Registration_2') {
        this.setState({ showEmailVerificationWall: true });
      }
    }
  }

  componentWillUnmount() {
    if (this.registrationDelayTimer) {
      clearTimeout(this.registrationDelayTimer);
    }
  }

  handleRegistrationModal = () => {
    const { doLoadTreatments, pageViews, treatments } = this.props;
    const regWallTreatment =
      treatments[SL_REGISTRATION_POPUP_V1] || doLoadTreatments(SL_REGISTRATION_POPUP_V1);
    if (regWallTreatment === 'Forced_KBYG_Registration_2') {
      this.setState({ showRegWall: true });
    }
    if (regWallTreatment === 'Second_Delay_Popup' && (pageViews === 3 || pageViews % 10 === 0)) {
      if (this.registrationDelayTimer) {
        clearTimeout(this.registrationDelayTimer);
      }
      this.registrationDelayTimer = setTimeout(() => {
        this.setState({ showTimedRegistrationModal: true });
      }, 10000);
    }
  };

  closeRegistrationModal = () => this.setState({ showTimedRegistrationModal: false });

  render() {
    const { createAccountUrl, device, isPremium, userDetails } = this.props;
    const {
      adBlocker,
      showRegWall,
      showEmailVerificationWall,
      showTimedRegistrationModal,
    } = this.state;
    const adBlockOff = adBlocker === 'off';
    return (
      <div>
        <DetectAdBlock
          setAdBlock={(enabled) => {
            if (enabled) {
              this.setState({ adBlocker: 'on' });
            } else {
              this.setState({ adBlocker: 'off' });
            }
          }}
        />
        {showEmailVerificationWall && adBlockOff && !isPremium ? (
          <EmailVerification userDetails={userDetails} />
        ) : null}
        {showRegWall && adBlockOff ? <ForcedRegistrationModal /> : null}
        {showTimedRegistrationModal && adBlockOff ? (
          <RegistrationModal
            registrationURL={createAccountUrl}
            isOpen={showTimedRegistrationModal}
            onClose={this.closeRegistrationModal}
            device={device}
          />
        ) : null}
      </div>
    );
  }
}

RegistrationModals.defaultProps = {
  userDetails: null,
  treatments: {},
};

RegistrationModals.propTypes = {
  createAccountUrl: PropTypes.string.isRequired,
  device: devicePropTypes.isRequired,
  doLoadTreatments: PropTypes.func.isRequired,
  isPremium: PropTypes.bool.isRequired,
  pageViews: PropTypes.number.isRequired,
  treatments: treatmentsPropType,
  userDetails: userDetailsPropType,
};

export default RegistrationModals;
